import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=feeaa998&scoped=true&"
import script from "./Copyright.vue?vue&type=script&lang=js&"
export * from "./Copyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeaa998",
  null
  
)

export default component.exports